// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2y4SZ","actions":"GroupTable_actions__1n6Kv","deleteModalFooter":"GroupTable_deleteModalFooter__EaHXe"};